<template>
  <div v-if="tb_conclusion" class="card card-content">
    <h6>TB Conslusion</h6>
    <form>
      <div class="row">
        <div class="input-field col s12">
          <span>TB Status</span>
          <select v-model="tb_conclusion.tb_status">
            <option value selected>Choose your option</option>
            <option value="1" v-if="is_add_done">TB</option>
            <option value="2" v-if="!not_no_tb">No TB</option>
            <option value="3">MDRTB</option>
          </select>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <span>TB / MDRTB / IPT code</span>
            <input type="text" v-model="tb_conclusion.code" />
          </div>
        </div>
        <div class="input-field col s12" v-show="show1">
          <span>Defined TB Type</span>
          <select v-model="tb_conclusion.tb_site">
            <option value selected>Choose your option</option>
            <option value="1">Pulmonary BC</option>
            <option value="2">Extra Pulmonary BC</option>
            <option value="3">Pulmonary CD</option>
            <option value="4">Extra Pulmonary CD</option>
          </select>
        </div>

        <div class="input-field col s12" v-show="show1">
          <span>Treatment Status</span>
          <select v-model="tb_conclusion.treatment_status" @change="treatmentStatusChange">
            <option value selected>Choose your option</option>
            <option value="1">Received TB Treatment</option>
            <option value="2">Refer to other township</option>
            <option value="3">Initial Loss</option>
            <option value="4">Died before Treatment</option>
          </select>
        </div>
        <div class="input-field col s12" v-show="show2">
          <span>Treatment Start Date</span>
          <input
            type="text"
            placeholder="YYYY-MM-DD"
            v-model.lazy="tb_conclusion.start_date"
            class="datepicker"
            readonly
          />
        </div>

        <div class="input-field col s12" v-show="show1 && show2">
          <span>Treatment Regimen</span>
          <select v-model="tb_conclusion.treatment_reg">
            <option value selected>Choose your option</option>
            <option value="1">Initial Regimen</option>
            <option value="2">Retreatment Regiment</option>
            <option value="3">Childhood Regiment</option>
            <option value="4">MDRTB Regiment</option>
          </select>
        </div>
        <div class="input-field col s12" v-show="show2">
          <span>Type of TB Patients</span>
          <select v-model="tb_conclusion.tb_type">
            <option value selected>Choose your option</option>
            <option value="1">New</option>
            <option value="2">Relapse</option>
            <option value="3">Treatment after failure</option>
            <option value="4">Treatment after loss to follow up</option>
            <option value="5">Other previously treated</option>
            <option value="6">Previous treatment history unknown</option>
          </select>
        </div>
        <div class="input-field col s12" v-show="show1">
          <span>Smoking status</span>
          <select v-model="tb_conclusion.smoking_status">
            <option value selected>Choose your option</option>
            <option value="1">Current</option>
            <option value="2">Never</option>
            <option value="3">Past</option>
          </select>
        </div>
        <div class="input-field col s12" v-show="show1">
          <span>DM status</span>
          <select v-model="tb_conclusion.dm_status">
            <option value selected>Choose your option</option>
            <option value="1">Yes</option>
            <option value="2">No</option>
            <option value="3">Unknown</option>
          </select>
        </div>
        <div class="input-field col s12" v-show="show2">
          <span>HIV status</span>
          <select v-model="tb_conclusion.hiv_status">
            <option value selected>Choose your option</option>
            <option value="1">Positive</option>
            <option value="2">Negative</option>
            <option value="3">Unknown</option>
          </select>
        </div>
        <div class="input-field col s12" v-show="show2 && showHIV">
          <span>CPT Date</span>
          <input
            type="text"
            placeholder="YYYY-MM-DD"
            v-model.lazy="tb_conclusion.cpt_date"
            class="datepicker"
            readonly
          />
        </div>
        <div class="input-field col s12" v-show="show2 && showHIV">
          <span>ART Date</span>
          <input
            type="text"
            placeholder="YYYY-MM-DD"
            v-model.lazy="tb_conclusion.art_date"
            class="datepicker"
            readonly
          />
        </div>
        <div class="input-field col s12" v-show="show2 && showHIV">
          <span>HIV Care</span>
          <select v-model="tb_conclusion.hiv_care">
            <option value selected>Choose your option</option>
            <option value="1">IHC</option>
            <option value="2">NAP</option>
            <option value="3">Other</option>
          </select>
        </div>
        <div class="input-field col s12" v-show="show2 && showHIV">
          <span>HIV Code</span>
          <input type="number" v-model="tb_conclusion.hiv_code" />
        </div>
        <div class="input-field col s12" v-show="show1 && show2">
          <span>Treatment outcome</span>
          <select v-model="tb_conclusion.treatment_outcome">
            <option value selected>Choose your option</option>
            <option value="1">Cured</option>
            <option value="2">Treatment complete</option>
            <option value="3">Treatment failure</option>
            <option value="4">Died</option>
            <option value="5">Lost to follow up</option>
            <option value="6">Not evaluated</option>
            <option value="7">Moved to second line treatment</option>
          </select>
        </div>
        <div class="input-field col s12" v-show="show2 && this.tb_conclusion.treatment_outcome">
          <span>Outcome Date</span>
          <input
            type="text"
            placeholder="YYYY-MM-DD"
            v-model.lazy="tb_conclusion.outcome_date"
            class="datepicker"
            readonly
          />
        </div>

        <div class="input-field col s12">
          <span>Remark</span>
          <textarea class="materialize-textarea" v-model="tb_conclusion.remark"></textarea>
        </div>

        <div class="row center">
          <button
            type="button"
            class="btn blue darken-3"
            @click="submit"
            :disabled="updateloading"
            v-if="buttonpass"
          >Edit</button>
        </div>
      </div>
    </form>
  </div>
  <new-tb-conclusion v-else></new-tb-conclusion>
</template>

<script>
import NewTBConclusion from "@/components/Patient/Fill/TBConclusion/NewTBConclusion.vue";
export default {
  name: "TBConclusion",
  data() {
    return {};
  },
  components: {
    "new-tb-conclusion": NewTBConclusion,
  },
  mounted() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});
    var elems = document.querySelectorAll(".datepicker");
    var instances = M.Datepicker.init(elems, {
      format: "yyyy-mm-dd",
      showClearBtn: true,
    });
  },
  watch: {},
  methods: {
    submit() {
      var data = {
        tb_status: this.tb_conclusion.tb_status,
        treatment_status: this.tb_conclusion.treatment_status,
        code: this.tb_conclusion.code,
        tb_type: this.tb_conclusion.tb_type,
        tb_site: this.tb_conclusion.tb_site,
        treatment_reg: this.tb_conclusion.treatment_reg,
        start_date: this.tb_conclusion.start_date,
        treatment_outcome: this.tb_conclusion.treatment_outcome,
        dm_status: this.tb_conclusion.dm_status,
        smoking_status: this.tb_conclusion.smoking_status,
        hiv_status: this.tb_conclusion.hiv_status,
        remark: this.tb_conclusion.remark,
      };

      if (data.hiv_status == 1) {
        data.hiv_care = this.tb_conclusion.hiv_care;
        data.hiv_code = this.tb_conclusion.hiv_code;
        data.cpt_date = this.tb_conclusion.cpt_date;
        data.art_date = this.tb_conclusion.art_date;
      }

      if (!this.show1) {
        data.treatment_status = null;
        data.smoking_status = null;
        data.dm_status = null;
      }

      if (!this.show2) {
        data.tb_type = null;
        data.tb_site = null;
        data.treatment_reg = null;
        data.start_date = null;
        data.treatment_outcome = null;
        data.hiv_status = null;
      }

      if (data.treatment_outcome) {
        data.outcome_date = this.tb_conclusion.outcome_date;
      }

      data.id = this.patient.id;
      this.$store.dispatch("submitTBConclusion", data);
    },
  },

  computed: {
    patient() {
      return this.$store.getters.patient;
    },
    is_add_done() {
      if (this.patient.metadata.refer_from == 5) {
        return true;
      } else {
        if (
          (this.patient.chest_xray && this.patient.chest_xray.done == 1) ||
          (this.patient.sputum && this.patient.sputum.done) == 1 ||
          (this.patient.gene_xpert && this.patient.gene_xpert.done == 1) ||
          (this.patient.tuberculinskin &&
            this.patient.tuberculinskin.done == 1) ||
          (this.patient.fnac && this.patient.fnac.done == 1)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    not_no_tb() {
      if (this.patient.metadata.refer_from == 5) {
        return false;
      } else {
        if (
          // this.patient.sputum.result == 2 ||
          this.patient.gene_xpert.result == 2 ||
          this.patient.fnac.result == 2
        ) {
          return true;
        } else {
          return false;
        }
      }
    },

    tb_conclusion() {
      var item = localStorage.getItem("current_data");
      var data = this.$store.getters.patient.tb_conclusion;
      if (!item) {
        localStorage.setItem("current_data", JSON.stringify(data));
      }

      return data;
    },

    buttonpass() {
      if (this.tb_conclusion.tb_status) {
        return true;
      } else {
        return false;
      }
    },
    updateloading() {
      return this.$store.getters.updateloading;
    },
    show1() {
      if (
        this.patient.tb_conclusion.tb_status != 0 &&
        this.patient.tb_conclusion.tb_status != 2
      ) {
        return true;
      } else {
        return false;
      }
    },
    show2() {
      if (
        this.patient.tb_conclusion.tb_status != 2 &&
        this.patient.tb_conclusion.treatment_status
      ) {
        if (
          this.patient.tb_conclusion.treatment_status == 1 ||
          this.patient.tb_conclusion.treatment_status == 2
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showHIV() {
      if (this.patient.tb_conclusion.hiv_status == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fill {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
}

.fill .card {
  padding: 20px;
}
</style>
